import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { ContactInfo } from "../../home/models/ContactInfo";
import {
    BankAccountModel, InvoiceDetailModel, PrintInvoiceLabelModel,
    PrintInvoiceLabelWrapper, PrintInvoiceModelWrapper
} from "../models/InvoiceModel";
import { InvoicePrintService } from "../services/InvoicePrintService";

export function useInvoicePrintVM() {
    const invoiceService = new InvoicePrintService();

    const [invoices, setInvoices] = useState<InvoiceDetailModel[]>([]);
    const [contacts, setContacts] = useState<ContactInfo[]>([]);
    const [bankAccounts, setBankAccounts] = useState<BankAccountModel[]>([]);
    const [note, setNote] = useState<string>("");

    const [labels, setLabels] = useState<PrintInvoiceLabelModel[]>([]);
    const [senderNumber, setSenderNumber] = useState<string>("");
    const [rielsExchangeRate, setRielsExchangeRate] = useState<number>(0);
    const [listHash, setListHash] = useState<number>(0);

    const [loading, setLoading] = useState(false);

    const get = (id: string) => {
        setLoading(true);
        setInvoices([]);
        setContacts([]);
        setBankAccounts([]);
        setNote("");
        setRielsExchangeRate(0);

        const request = invoiceService.get(id);
        DataUtils.onRequest(request, onGetResult);
    }

    const onGetResult = (result: IDataResult) => {
        const model = result.data as PrintInvoiceModelWrapper | null | undefined;

        if (result.status === ResponseStatus.success && model) {
            setInvoices(model.invoices);
            setContacts(model.contacts);
            setBankAccounts(model.bankAccounts);
            setNote(model.note ?? "");
            setRielsExchangeRate(model.rielsExchangeRate);
        }

        setListHash(Utils.getRandomKey());
        setLoading(false);
    }

    const getLabels = (ids: string) => {
        const request = invoiceService.getForLabel(ids);
        DataUtils.onRequest(request, onGetLabelsResult);
    }

    const onGetLabelsResult = (result: IDataResult) => {
        const model = result.data as PrintInvoiceLabelWrapper | null | undefined;

        if (result.status === ResponseStatus.success && model) {
            setLabels(model.invoices);
            setSenderNumber(model.senderNumber);
            setRielsExchangeRate(model.rielsExchangeRate);
        }

        setListHash(Utils.getRandomKey());
        setLoading(false);
    }

    return {
        invoices,
        contacts,
        bankAccounts,
        note,
        rielsExchangeRate,

        labels,
        senderNumber,

        loading, setLoading,
        listHash,

        get,
        getLabels
    }
}